module.exports = __webpack_public_path__ + "img/flow_4.0ec1705e.png";